import { useMutation, useQuery } from "@tanstack/react-query";
import { masterchecklistservice } from "modules/Library/Checklist/api/checklist.api";
import { perPageData } from "common/service/CommonService";


export const useCheckListMasterService = (params: any = {}) => {
    const { pageNumber = 1, pageSize = perPageData, searchText = "", ispagination, checklisttype, enabled, checklistcategory, typeEnabled } = params;

    const SelectAllQuery = useQuery({
        queryKey: ["checklist-master-selectAll", { pageNumber, pageSize, searchText, ispagination, checklisttype , checklistcategory }],
        queryFn: () =>
            masterchecklistservice.getSelectAllData({
                currentpage: pageNumber,
                pagesize: pageSize,
                searchtext: searchText,
                ispagination: ispagination,
                checklisttype: checklisttype,
                checklistcategory: checklistcategory || "",
            }),
        enabled: enabled !== undefined ? enabled : (ispagination === false ? true : !!(pageNumber && pageSize)),
    });

    const ChecklistTypeSelectAllQuery = useQuery({
        queryKey: ["checklist-type-selectAll", { pageNumber, pageSize, searchText, checklistcategory }],
        queryFn: () =>
            masterchecklistservice.getChecklistTypeSelectAllData({
                currentpage: pageNumber,
                pagesize: pageSize,
                searchtext: searchText,
                checklistcategory: checklistcategory,
            }),
        enabled: typeEnabled !== undefined ? typeEnabled : true,
    });

    const InsertMutation = useMutation({
        mutationFn: (payload: any) => masterchecklistservice.insertData(payload),
    });

    const UpdateMutation = useMutation({
        mutationFn: (payload: any) => masterchecklistservice.updateData(payload),
    });

    const DeleteMutation = useMutation({
        mutationFn: (payload: any) => masterchecklistservice.deleteData(payload),
    });

    const AssignCategoryMutation = useMutation({
        mutationFn: (payload: any) => masterchecklistservice.assignCategory(payload),
    });

    const UpdateCategoryMutation = useMutation({
        mutationFn: (payload: any) => masterchecklistservice.updateCategory(payload),
    });

    const UpdateDisplayOrderMutation = useMutation({
        mutationFn: (payload: any) => masterchecklistservice.updateDisplayOrder(payload),
    });

    return {
        SelectAllQuery,
        ChecklistTypeSelectAllQuery,
        InsertMutation,
        UpdateMutation,
        DeleteMutation,
        AssignCategoryMutation,
        UpdateCategoryMutation,
        UpdateDisplayOrderMutation,
    };
};